export const MuiBackdrop = {
  MuiBackdrop: {
    styleOverrides: {
      root: {
        backgroundColor: "rgba(217, 217, 217, 0.7)",
      },
    },
  },
};
